import styled, { keyframes } from 'styled-components'
import { media } from '../../../utils/mediaQuery'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-flex;
`

interface TooltipContentPortalProps {
  $placement: 'top' | 'bottom' | 'left' | 'right'
  $maxWidth: number
  $top: number
  $left: number
  $positioned: boolean
}

export const TooltipContentPortal = styled.div<TooltipContentPortalProps>`
  position: fixed;
  z-index: 10000;
  top: ${({ $top }) => $top}px;
  left: ${({ $left }) => $left}px;
  padding: 10px 14px;
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.5;
  font-weight: 500;
  white-space: normal;
  word-wrap: break-word;
  max-width: ${({ $maxWidth }) => $maxWidth}px;
  pointer-events: none;
  animation: ${fadeIn} 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.15),
    0 2px 4px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  opacity: ${({ $positioned }) => ($positioned ? 1 : 0)};

  ${media.mobileOnly} {
    max-width: min(250px, 90vw);
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
`
